"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInput = exports.PasswordInput = exports.DateInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _InputOutline = require("./InputOutline");
var _InputLine = require("./InputLine");
var _excluded = ["type"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var MAP_INPUT_TYPE = {
  'outline': _InputOutline.InputOutline,
  'line': _InputLine.InputLine
};
var GeneralInput = function GeneralInput(_ref) {
  var type = _ref.type,
    moreProps = _objectWithoutProperties(_ref, _excluded);
  var defaultInputType = 'outline'; // TODO: add transparent (set it as default?)
  var InputComponent = MAP_INPUT_TYPE[type] || MAP_INPUT_TYPE[defaultInputType];
  return /*#__PURE__*/_react["default"].createElement(InputComponent, moreProps);
};
var TextInput = exports.TextInput = function TextInput(props) {
  return /*#__PURE__*/_react["default"].createElement(GeneralInput, _extends({
    inputType: "text"
  }, props));
};
var PasswordInput = exports.PasswordInput = function PasswordInput(props) {
  return /*#__PURE__*/_react["default"].createElement(GeneralInput, _extends({
    inputType: "password"
  }, props));
};
var DateInput = exports.DateInput = function DateInput(props) {
  return /*#__PURE__*/_react["default"].createElement(GeneralInput, _extends({
    inputType: "date"
  }, props));
};